import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Pagination } from "../../../Utils";
import {
  ErrorToast,
  TextArea,
  SuccessToast,
  Confirmation,
} from "../../../Utils/SweetAlert";
import {
  GetCustomerWalletRequestPaginate,
  ApproveRejectCustomerWalletRequest,
  DeleteCustomerWalletRequest,
} from "../../../Services/Api/customer";
import format from "date-fns/format";
import { Helmet } from "react-helmet-async";
import { StartCase } from "react-lodash";
import _ from "lodash";
import { showCustName } from "../../../Utils/CommanFunctions";
import { IconButton } from "@mui/material";

const WalletRequest = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [customerWalletRequest, setCustomerWalletRequest] = useState([]);

  const getCustomerList = async (limitO = "", pageO = "") => {
    setIsLoading(true);
    await GetCustomerWalletRequestPaginate({ limit: limitO, page: pageO })
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.data?.totalRecords > 0) {
          setCustomerWalletRequest(res?.data?.data?.transactions);
          setTotalRecords(res?.data?.data?.totalRecords);
        } else {
          setCustomerWalletRequest([]);
          setTotalRecords(0);
          // ErrorToast("No Results.");
        }
      })
      .catch((err) => {
        setCustomerWalletRequest([]);
        setTotalRecords(0);
        setIsLoading(false);
        // if (typeof err.response.data.message !== "undefined") {
        //   ErrorToast(err.response.data.message || "Server Error!!");
        // } else {
        //   ErrorToast(err?.message || "Server Error!!");
        // }
      });
  };
  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
  };
  const handleLimitChange = async (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getCustomerList(limit, page);
  }, [limit, page]);

  // const approveRequest = (item, mode = 1) => {
  //   var postObj = { "transaction_id": item._id, "status": mode, "reject_reason": "" };
  //   if (mode == 1) {
  //     Confirmation("Want to approve wallet request?").then(async (result) => {
  //       if (result.isConfirmed) {
  //         await makeApproveReject(postObj);
  //       }
  //     });
  //   } else if (mode == 2) {
  //     TextArea({ denyButtonText: "Cancel" }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         postObj.reject_reason = result.value;
  //         await makeApproveReject(postObj);
  //       }
  //     });
  //   } else if (mode == 3) {
  //     Confirmation("Want to delete wallet request?").then(async (result) => {
  //       if (result.isConfirmed) {
  //         await DeleteCustomerWalletRequest(postObj.transaction_id)
  //           .then((res) => {
  //             SuccessToast(res?.data?.message || "Status Updated");
  //             getCustomerList(limit, page);
  //           })
  //           .catch((err) => {
  //             // if (typeof err.response.data.message !== "undefined") {
  //             //   ErrorToast(err.response.data.message || "Server Error!!");
  //             // } else {
  //             //   ErrorToast(err?.message || "Server Error!!");
  //             // }
  //           });
  //       }
  //     });
  //   }
  // };

  async function makeApproveReject(postObj) {
    await ApproveRejectCustomerWalletRequest(postObj)
      .then((res) => {
        SuccessToast(res?.data?.message || "Status Updated");
        getCustomerList(limit, page);
      })
      .catch((err) => {
        // if (typeof err.response.data.message !== "undefined") {
        //   ErrorToast(err.response.data.message || "Server Error!!");
        // } else {
        //   ErrorToast(err?.message || "Server Error!!");
        // }
      });
  }
  return (
    <>
      <Helmet>
        <title>CPay | Admin Cash / Cheque Deposit</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Cash / Cheque Deposit</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {" "}
                    Cash / Cheque Deposit
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* common component import here */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-stripped table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Receipt</th>
                          <th className="text-center">Action</th>
                          <th>Reference Number</th>
                          <th>Client</th>
                          <th>Bank Details</th>
                          <th>Type</th>
                          <th>Deposited Amount</th>
                          <th>Credited Amount</th>
                          <th>Bank Reference</th>
                          <th>User Reference</th>
                          <th>On Behalf Of</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading && (
                          <>
                            {customerWalletRequest.map((customer, index) => (
                              <tr
                                key={index}
                                className={
                                  customer.status == 0
                                    ? "table-pending"
                                    : "table-white"
                                }
                              >
                                <td>{limit * page + (index + 1)}</td>
                                <td>
                                  {customer.status === 1 && (
                                    <span className="badge badge-pill bg-success-light">
                                      Approved
                                    </span>
                                  )}
                                  {customer.status === 2 && (
                                    <span className="badge badge-pill bg-danger-light">
                                      Rejected
                                    </span>
                                  )}
                                  {customer.status === 0 && (
                                    <>
                                      <span className="badge badge-pill bg-warning-light">
                                        Pending
                                      </span>
                                    </>
                                  )}
                                </td>
                                <td>
                                  <a href={customer?.receipt_file} className="btn btn-sm btn-white text-warning me-2" rel="noreferrer" target="_blank">
                                    View Receipt
                                  </a>
                                </td>
                                <td>
                                  {customer.status === 0 ? (
                                    <>
                                      <span
                                        className="btn btn-sm btn-block btn-outline-success"
                                        style={{ margin_Top: "20px" }}
                                        onClick={() =>
                                          // navigate("/admin/wallet-details", {
                                          //   state: { tid: customer._id },
                                          // })
                                          navigate(`/admin/wallet-details/${customer._id}`)
                                        }
                                      >
                                        View Detail{" "}
                                      </span>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {customer.reference_number || "-"}
                                  <br />
                                  <span>
                                    {format(
                                      new Date(customer.createdAt),
                                      "dd MMMM, yyyy hh:mm a"
                                    )}
                                  </span>
                                </td>
                                <td>
                                  {
                                    (customer?.user?.name && customer?.user?.company_name)
                                    ?
                                      showCustName(customer?.user?.name, customer?.user?.company_name)
                                    :
                                      (customer?.user?.name)
                                      ?
                                        customer?.user?.name
                                      :
                                        ""
                                  }
                                </td>
                                <td>
                                  <span>{customer?.destination_bank?.title}</span>
                                  -
                                  <span>
                                    {customer?.destination_bank?.account_number}
                                  </span>
                                  &nbsp;&nbsp;
                                  <span>
                                    {customer?.destination_bank?.currency}
                                  </span>
                                  <br />
                                  <span>
                                    {customer?.destination_bank?.beneficiary}
                                  </span>
                                </td>
                                <td>
                                  <StartCase
                                    string={_.toLower(
                                      _.replace(customer.motive, "_", " ")
                                    )}
                                  />
                                </td>
                                <td>
                                  <span className="currency-type-text">
                                    {customer.deposited_currency}
                                  </span>{" "}
                                  {customer.deposited_amount}
                                </td>
                                <td>
                                  <span className="currency-type-text">
                                    {customer.transaction_currency}
                                  </span>{" "}
                                  {customer.transaction_amount}
                                </td>
                                <td>{customer.bank_reference}</td>
                                <td>{customer.user_reference}</td>
                                <td>{customer.on_behalf_of || "-"}</td>
                              </tr>
                            ))}
                            {customerWalletRequest.length === 0 && (
                              <tr>
                                <td colSpan={12}>No Records Found.</td>
                              </tr>
                            )}
                          </>
                        )}
                        <Pagination
                          totalItem={totalRecords}
                          itemsPerPage={limit}
                          page={page}
                          handleChangePage={handlePageChange}
                          handleChangeRowsPerPage={handleLimitChange}
                          colSpan={12}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className=" container-fluid absolute mb-4">
              <footer className="text-center text-lg-start">
                <div className="text-center">Powered by Alsaffron System.</div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletRequest;
